import { propEq } from 'ramda';

export const isBusinessAccount = propEq('isCompany', 'true');

export const isPersonalAccount = propEq('isCompany', 'false');
